import { render, staticRenderFns } from "./ChangeFeedbackForm.vue?vue&type=template&id=21168222"
import script from "./ChangeFeedbackForm.vue?vue&type=script&lang=js"
export * from "./ChangeFeedbackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports